// extracted by mini-css-extract-plugin
module.exports = {"container":"carousel-module__container___hwZe1","adjust":"carousel-module__adjust___Qg4aF"};